import { render } from "./api.vue?vue&type=template&id=2bc019c5&scoped=true"
import script from "./api.vue?vue&type=script&lang=js"
export * from "./api.vue?vue&type=script&lang=js"

import "./api.vue?vue&type=style&index=0&id=2bc019c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc019c5"]])

export default __exports__